import React, { Component } from "react"
import NavBarItems from "../navbar/navBarItems"
import { FaInstagram, FaMailBulk, FaLinkedinIn} from "react-icons/fa"
import configs from '../../../configs.json'

class Footer extends Component {
    render() {
        return (
            <footer className="page-footer" style={{backgroundColor: configs.colors.primary}}>
                <div className="container" id='footer'>
                    <div className="row">
                        <div className="col l6 s12 left-align">
                            <h4 style={{color:process.env.REACT_APP_COLORS_DARKER}}>{configs.name}</h4>
                            <a href='https://www.instagram.com/cloud.pharma/'><FaInstagram  className='social-icon hoverable' style={{color:'black'}} /></a>
                            <a href='mailto:cloudpharmacontato@gmail.com'>      <FaMailBulk   className='social-icon hoverable' style={{color:'black'}} /></a>
                            <a href='https://www.linkedin.com/company/cloud-pharma/'><FaLinkedinIn className='social-icon hoverable' style={{color:'black'}} /></a>
                        </div>
                        <div className="col l4 offset-l2 s12 left-align">
                            <h4 style={{color:process.env.REACT_APP_COLORS_DARKER}}>Links</h4>
                            <ul>
                                <NavBarItems color='black'/>
                            </ul>
                        </div>
                    </div>
                </div>
                <div style={{borderTop: '3px solid ' + configs.colors.secondary}}>
                    <div className="container  black-text footer-cpc">
                        <div className="row" style={{marginBottom: '0px'}}>
                            <div className="col s12 m6">
                                <div className="left">© {configs.copyright.year} {process.env.REACT_APP_URL}</div>
                            </div>
                            <div className="col s12 m6">
                                <a className="black-text right hide-on-small-only" href={configs.copyright.owner.link} >Powerd by {configs.copyright.owner.name}</a>
                                <a className="black-text left  hide-on-med-and-up" href={configs.copyright.owner.link} >Powerd by {configs.copyright.owner.name}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;